export default "__VITE_PUBLIC_ASSET__aca88627__"